import { useTranslation } from 'next-i18next'

import { Link } from '~/components/Link'
import SVGIcon from '~/components/Icons/svgs/SVGIcon'
import InvitePersonIcon from '~/components/Icons/svgs/InvitePersonIcon'
import ROUTES from '~/shared/constants/routes.const'

import { MenuCategoryKeys } from '../constants/category.const'
import useHandleItemClick from '../hooks/useGetHandlerItemClick'

export default function InviteFriendButton({ className = '' }: { className?: string }): React.ReactElement {
  const { t } = useTranslation('menu')
  const handleItemClick = useHandleItemClick()

  return (
    <Link
      className={`${className} flex h-11.5 shrink-0 items-center justify-center gap-2 whitespace-nowrap rounded-full border border-purple-half-deep px-3.5 text-xs font-medium leading-3 text-white`}
      data-test-id="menu-invite-friend"
      onClick={() => handleItemClick(MenuCategoryKeys.INVITE_FRIEND)}
      to={ROUTES.REFERRAL}
    >
      <SVGIcon icon={InvitePersonIcon} pathClassName="text-purple" size={16} />
      {t('inviteFriend')}
    </Link>
  )
}
